module.exports = __webpack_public_path__ + "img/img_hula_img1.21d304b4.png";